import Button from "@/components/button"
import { Bookmark, Heart, MessageCircle, Link as LinkIcon } from "@/components/icons/outline"
import CreatePost from "@/components/partials/create-post"
import CreateReply from "@/components/partials/create-reply"
import Spinner from "@/components/spinner"
import { useAuth } from "@/contexts/auth-context"
import Main from "@/layouts/main"
import usePostRepos from "@/repositories/post"
import axios from "axios"
import moment from "moment"
import { Link, useNavigate, useParams } from "react-router-dom"

export default function Explore({ filtered = false }) {
    // Contexts
    const { user, token } = useAuth()

    // Hooks
    const { slug } = useParams()
    const navigate = useNavigate()

    const { data: postData, isLoading: isLoadingPostData, mutate: mutatePostData } = usePostRepos({
        category: filtered ? slug : null
    })

    const toggleLikePost = (id) => {
        const baseUrl = process.env.REACT_APP_API_URL

        mutatePostData(postData?.map((row) => {
            if (row.id === id) {
                if (row.likePost.find((data) => (data.userId === user?.id && data.postId === id))) {
                    row.likePost = row.likePost.filter((data) => (data.userId !== user?.id && data.postId !== id))
                    row._count.likePost--

                    axios.delete(`${baseUrl}/posts/${id}/like`, { headers: { Authorization: `Bearer ${token}` } })
                } else {
                    row.likePost.push({ userId: user?.id, postId: id })
                    row._count.likePost++

                    axios.post(`${baseUrl}/posts/${id}/like`, {}, { headers: { Authorization: `Bearer ${token}` } })
                }
            }

            return row
        }), { optimisticData: true, revalidate: false })
    }

    return (
        <Main title={filtered ? "Category" : "Explore"} headerTitle={filtered ? "Category" : "Explore"} showBackButton={filtered}>
            <div className="divide-y">
                {!filtered && (
                    <>
                        {/* Create Post */}
                        <div className="p-6">
                            <div className="flex justify-between">
                                <div className="flex space-x-4">
                                    <div className="relative">
                                        <img className="w-10 h-10 rounded-xl" src={`https://ui-avatars.com/api/?name=${user?.name}`} alt={`${user?.name}'s Profile Picture`} />
                                    </div>
                                    <div className="flex items-center">
                                        <p className="text-neutral-500">What's up?</p>
                                    </div>
                                </div>
                                <CreatePost onSubmit={() => mutatePostData()} />
                            </div>
                        </div>
                    </>
                )}

                {isLoadingPostData && (
                    <div className="flex items-center justify-center p-6">
                        <Spinner />
                    </div>
                )}

                {/* Posts */}
                {!isLoadingPostData && postData?.map((row) => (
                    <div onClick={() => navigate(`/post/${row.id}`)} key={row.id} className="flex flex-col w-full p-6 space-y-6 cursor-pointer">
                        <div className="flex flex-col justify-between w-full space-y-4 md:space-y-0 md:flex-row">
                            <div className="flex space-x-4">
                                <div className="relative">
                                    <img className="w-10 h-10 rounded-xl" src={`https://ui-avatars.com/api/?name=${row.user?.name}`} alt={`${row.user?.name}'s Profile Picture`} />
                                </div>
                                <div className="flex flex-col items-start justify-between">
                                    {/* Name */}
                                    <p className="inline-flex items-center text-sm font-semibold">{row.user?.name} <span className="ml-1 text-xs text-neutral-500">{row.user?.role?.name}</span></p>
                                    {/* Timestamp */}
                                    <p className="text-xs text-neutral-500">{moment(row.createdAt).fromNow()}</p>
                                </div>
                            </div>
                            <div className="px-3 py-1 text-xs font-medium text-blue-500 bg-blue-100 border border-blue-500 rounded-full h-fit w-fit">{row.category?.name}</div>
                        </div>
                        <div className="flex flex-col items-start space-y-2">
                            {/* Content */}
                            <div className="text-sm">
                                {row.content}
                            </div>
                            {row.createdAt != row.updatedAt && (<p className="text-xs font-semibold text-neutral-400">Edited</p>)}
                        </div>
                        <div className="flex items-center justify-between w-full text-sm text-neutral-500">
                            <div className="flex items-center space-x-8">
                                {/* Likes */}
                                <button onClick={(e) => { e.stopPropagation(); toggleLikePost(row.id) }} className="flex items-center space-x-2 z-1">
                                    <Heart className={`${row.likePost.find((row) => row.userId === user?.id) ? 'text-red-500' : ''}`} fill={`${row.likePost.find((row) => row.userId === user?.id) ? 'currentColor' : 'none'}`} />
                                    <span>
                                        <p>{row._count.likePost}</p>
                                    </span>
                                </button>
                                {/* Reply */}
                                <CreateReply data={{ post: row }} label={row.reply?.length ?? 0} onSubmit={() => navigate(`/post/${row.id}`)} />
                            </div>
                            <div className="flex items-center space-x-8">
                                {/* Link */}
                                <button onClick={() => navigator.clipboard.writeText(`${process.env.REACT_APP_URL}/post/${row.id}`)}>
                                    <LinkIcon />
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </Main>
    )
}